(ns dashboard.views.home
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [clojure.string :refer [split lower-case join blank?]]
   [dashboard.utils :refer
    [listen cs format-percent href index-by index-of format-day format-time
     format-date]]
   [dashboard.subs :as subs]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.i18n :refer [tr]]
   [dashboard.events.spaces :as space-events]
   [dashboard.events.calendars :as calendar-events]
   [dashboard.events.bookings :as booking-events]
   [dashboard.components.button :refer [button]]
   [dashboard.components.table :refer [table pagination]]
   [dashboard.components.dialog :refer [dialog]]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.profile :refer [profile-img display-user-fullname]]
   [dashboard.components.select :refer [select space-select time-select]]
   [dashboard.components.calendar :refer [small-calendar-month]]
   [dashboard.components.datepicker :refer [datepicker]]
   [dashboard.components.tooltip :refer [tooltip]]
   [dashboard.components.tag :refer [tag]]
   [dashboard.components.inputs :refer [search-input]]
   ["@heroicons/react/solid" :refer
    [AnnotationIcon LocationMarkerIcon DotsHorizontalIcon CalendarIcon CheckIcon
     ChevronLeftIcon ChevronRightIcon ChevronDownIcon UserIcon UsersIcon
     UserGroupIcon ShoppingBagIcon XIcon]]
   ["date-fns" :refer
    [format getMonth setMonth parseISO isSaturday isSunday isAfter isBefore
     isToday isSameDay formatDistance parse isDate eachDayOfInterval]]))

(defn progress
  [{:keys [class steps disabled?]}]
  (let []
    [:nav
     {:aria-label "Progress"
      :class class}
     [:div.flex.items-center
      {:class (str "grid-cols-" (count steps))
       :role "list"}
      (doall
       (for [step steps]
         ^{:key (:id step)}
         [:span.flex-1.text-center
          [:span.text-xs.text-gray-500.whitespace-nowrap
           (:name step)]]))]
     [:ol.flex.items-center.px-6
      {:role "list"}
      (doall
       (for [step steps]
         ^{:key (:id step)}
         [:li
          {:class (cs "relative"
                      (when (not= (:id step) (:id (last steps)))
                        "pr-4 sm:pr-12"))}
          [:<>
           [:div.absolute.inset-0.flex.items-center
            {:aria-hidden true}
            [:div.w-full
             {:class (cs "h-0.5"
                         (if (and (:checked? step) (not (:current? step)))
                           "bg-primary-600" "bg-gray-200"))}]]
           [:a.relative.flex.h-6.w-6.items-center.justify-center.rounded-full
            {:on-click (:on-click step)
             :disabled disabled?
             :aria-current (when (:current? step) "step")
             :class (cs ""
                        (if (:checked? step)
                          "bg-primary-600 hover:bg-primary-900" "border-2 border-gray-300 bg-white")
                        (if (and (some? (:on-click step)) (not disabled?))
                          "cursor-pointer hover:border-gray-400" "cursor-not-allowed"))}
            (if (:current? step)
              [:span.rounded-full.bg-white
               {:class "h-2 w-2"
                :aria-hidden true}]
              (if (:checked? step)
                [:> CheckIcon
                 {:class "h-4 w-4 text-white"}]
                [:span.rounded-full.bg-transparent.group-hover:bg-gray-300
                 {:class "h-2.5 w-2.5"
                  :aria-hidden true}]))
            [:span.sr-only
             (:id step)]]]]))]
     [:ol.flex.items-center
      {:role "list"}
      (doall
       (for [step steps]
         ^{:key (:id step)}
         [:li.flex-1.text-center
          [:span.text-xs.text-gray-500
           (when (some? (:ts step))
             (format-time (js/Date. (:ts step))))]]))]]))

(defn- booking-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1

   [:p.text-sm
    (:productName (:booking @state))]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex.text-xs
       (tr :booking.status/check-in-time)]]]
    [:div.sm:col-span-2.flex.space-x-2
     [time-select
      {:class "w-24"
       :disabled? (= (:action @state) :view)
       :start-time "10:00"
       :end-time "20:40"
       :step-minutes 10
       :selected {:id (when (isDate (get-in @state [:booking :checkIn]))
                        (format (get-in @state [:booking :checkIn]) "HH:mm"))
                  :name (when (isDate (get-in @state [:booking :checkIn]))
                          (format (get-in @state [:booking :checkIn]) "HH:mm"))}
       :on-change #(do
                     (re-frame/dispatch [::booking-events/update-booking
                                         {:booking (assoc (:booking @state)
                                                          :checkIn (parse % "HH:mm" (:date @state)))}])
                     (swap! state assoc-in [:booking :checkIn] (parse % "HH:mm" (:date @state))))}]

     [:button
      {:on-click #(do
                    (re-frame/dispatch [::booking-events/update-booking
                                        {:booking (assoc (:booking @state) :checkIn nil)}])
                    (swap! state assoc-in [:booking :checkIn] nil))}
      [:> XIcon
       {:class "h-5 w-5 text-danger"}]]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :booking.status/enter-time)]]]
    [:div.sm:col-span-2.flex.space-x-2
     [time-select
      {:class "w-24"
       :disabled? true
       :start-time "10:00"
       :end-time "20:40"
       :step-minutes 10
       :selected {:id (when (isDate (get-in @state [:booking :enter]))
                        (format (get-in @state [:booking :enter]) "HH:mm"))
                  :name (when (isDate (get-in @state [:booking :enter]))
                          (format (get-in @state [:booking :enter]) "HH:mm"))}
       :on-change #(swap! state assoc-in [:booking :enter]
                          (parse % "HH:mm" (get-in @state [:booking :enter])))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :booking.status/exit-time)]]]
    [:div.sm:col-span-2.flex.space-x-2
     [time-select
      {:class "w-24"
       :disabled? true
       :start-time "10:00"
       :end-time "20:40"
       :step-minutes 10
       :selected {:id (when (isDate (get-in @state [:booking :exit]))
                        (format (get-in @state [:booking :exit]) "HH:mm"))
                  :name (when (isDate (get-in @state [:booking :exit]))
                          (format (get-in @state [:booking :exit]) "HH:mm"))}
       :on-change #(swap! state assoc-in [:booking :exit]
                          (parse % "HH:mm" (get-in @state [:booking :exit])))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex.text-xs
       (tr :booking.status/check-out-time)]]]
    [:div.sm:col-span-2.flex.space-x-2
     [time-select
      {:class "w-24"
       :disabled? (= (:action @state) :view)
       :start-time "10:00"
       :end-time "20:40"
       :step-minutes 10
       :selected {:id (when (isDate (get-in @state [:booking :checkOut]))
                        (format (get-in @state [:booking :checkOut]) "HH:mm"))
                  :name (when (isDate (get-in @state [:booking :checkOut]))
                          (format (get-in @state [:booking :checkOut]) "HH:mm"))}
       :on-change #(do
                     (re-frame/dispatch [::booking-events/update-booking
                                         {:booking (assoc (:booking @state)
                                                          :checkOut (parse % "HH:mm" (:date @state)))}])
                     (swap! state assoc-in [:booking :checkOut] (parse % "HH:mm" (:date @state))))}]
     [:button
      {:on-click #(do
                    (re-frame/dispatch [::booking-events/update-booking
                                        {:booking (assoc (:booking @state) :checkOut nil)}])
                    (swap! state assoc-in [:booking :checkOut] nil))}
      [:> XIcon
       {:class "h-5 w-5 text-danger"}]]]]])

(defn- comment-tooltip [{:keys [comment]}]
  [tooltip
   [:div.mt-2.max-w-2xl.whitespace-normal
    comment]])

(defn- guests-tooltip [{:keys [guests]}]
  [tooltip
   (doall
    (for [guest guests]
      ^{:key (gensym)}
      [:div.flex.px-2
       [:span.font-semibold
        (:name guest)]
       [:span.ml-4.text-gray-600.text-sm
        (:gender guest)]
       (when (some? (:age guest))
         [:span.ml-2.text-gray-600.text-sm
          (str (:age guest) "歳")])]))])

(defn event-organizer-home-page []
  (reagent/with-let
    [selected-date (reagent/atom (listen ::event-organizer-subs/default-selected-date))
     !booking-drawer-state (reagent/atom {:is-open? false
                                          :booking nil
                                          :date nil})
     !collapsed-state (reagent/atom {})
     !input-string (reagent/atom "")]
    (fn []
      (let [allowed-action (->> (listen ::subs/user-role)
                                :permissions
                                (filter #(= (:resource %) :shifts))
                                (first)
                                :action)
            selected-date-str (format @selected-date "yyyy-MM-dd")
            event (listen ::event-organizer-subs/selected-event)
            current-bookings (get (listen ::event-organizer-subs/bookings-by-date) selected-date-str)
            checked-in-bookings (->> current-bookings
                                     (filter #(some? (:checkIn %))))
            checked-out-bookings (->> current-bookings
                                      (filter #(some? (:checkOut %))))
            filtered-bookings (cond->> current-bookings
                                (not (blank? @!input-string))
                                (filter #(or
                                          (when (some? (:guestFirstName %))
                                            (>= (.indexOf
                                                 (.toLowerCase (:guestFirstName %))
                                                 (.toLowerCase @!input-string))
                                                0))
                                          (when (some? (:guestFirstNameJp %))
                                            (>= (.indexOf
                                                 (.toLowerCase (:guestFirstNameJp %))
                                                 (.toLowerCase @!input-string))
                                                0))
                                          (when (some? (:guestLastName %))
                                            (>= (.indexOf
                                                 (.toLowerCase (:guestLastName %))
                                                 (.toLowerCase @!input-string))
                                                0))
                                          (when (some? (:guestLastNameJp %))
                                            (>= (.indexOf
                                                 (.toLowerCase (:guestLastNameJp %))
                                                 (.toLowerCase @!input-string))
                                                0))
                                          (when (some? (:externalId %))
                                            (>= (.indexOf
                                                 (.toLowerCase (:externalId %))
                                                 (.toLowerCase @!input-string))
                                                0)))))]
        [:div
         [drawer
          {:state !booking-drawer-state
           :title (str
                   (:startTime (:booking @!booking-drawer-state))
                   " - "
                   (:guestLastNameJp (:booking @!booking-drawer-state))
                   "　"
                   (:guestFirstNameJp (:booking @!booking-drawer-state)))
           :content [booking-drawer-content
                     {:state !booking-drawer-state}]}]
         [:div.grid.grid-cols-1.gap-4.items-start.lg:grid-cols-3.lg:gap-8
          ;; Left Column
          (when (some? event)
            [:div.grid.grid-cols-1.gap-4.lg:col-span-3
             [:section
              {:aria-labelledby "event-overview-title"}
              [:div.rounded-lg.bg-white.overflow-hidden.shadow
               [:h2.sr-only
                {:id "event-overview-title"}]
               [:div.bg-white.p-6
                [:div.sm:flex.sm:items-center.sm:justify-between
                 [:div.sm:flex.sm:space-x-5
                  [:div.flex-shrink-0
                   [:div.w-20.border
                    [:div.flex.items-center.justify-center.border-b.bg-gray-100
                     (format @selected-date "EEEE" #js {:locale (listen :dashboard.subs/date-fns-locale)})]
                    [:div.flex.flex-col.justify-center.items-center.h-16
                     [:span.text-2xl.font-bold
                      (format-day @selected-date)]]]]
                  [:div.mt-4.text-center.sm:mt-0.sm:pt-1.sm:text-left
                   [:p.flex.space-x-2.items-end
                    [:span.text-xl.font-bold.text-gray-900.sm:text-2xl
                     (:name event)]
                    [:span.text-sm.font-medium.text-gray-600.mb-1.whitespace-nowrap
                     (if (isSameDay (:start event) (:end event))
                       [:span
                        (format-day (:start event) {:month? true})]
                       [:span
                        (format-day (:start event) {:month? true})
                        " → "
                        (format-day (:end event) {:month? true})])]
                    [:span.ml-2.px-2.rounded-full.text-sm.font-medium.bg-gray-100.text-gray-800.mb-1.whitespace-nowrap
                     (str (formatDistance (:start event) (js/Date.) #js {:addSuffix true
                                                                         :locale (listen ::subs/date-fns-locale)})
                          "のイベント")]]
                   [:p.text-sm.font-medium.text-gray-600.mt-2
                    (:title (listen ::subs/userinfo))]
                   [:div.flex.mt-1
                    [:div.leading-6.divide-x.divide-gray-100.border.border-gray-100.flex
                     (doall
                      (for [day (eachDayOfInterval #js {:start (:start event)
                                                        :end (:end event)})
                            :let [selected? (isSameDay day @selected-date)
                                  past? (isBefore day (listen ::subs/time))]]
                        ^{:key (format day "yyyy-MM-dd")}
                        [:div.px-2.py-1.text-xs.cursor-pointer
                         {:class (cs ""
                                     (if selected?
                                       "bg-primary-500 text-white"
                                       (if past?
                                         "bg-gray-50 text-gray-700"
                                         "text-gray-700")))
                          :on-click #(reset! selected-date day)}
                         (format-day day)]))]]
                   [:p.pt-2.text-gray-700
                    [:span.text-xs
                     "予約 "]
                    [:span.text-base.font-semibold
                     (count current-bookings)]
                    [:span.text-xs
                     "件・チェックイン "]
                    [:span.text-base.font-semibold
                     (count checked-in-bookings)]
                    [:span.text-xs
                     "件・チェックアウト "]
                    [:span.text-base.font-semibold
                     (count checked-out-bookings)]
                    [:span.text-xs
                     "件"]]]]

                 [:div.mt-5.flex.justify-center.sm:mt-0
                  [:a.flex.justify-center.items-center.px-4.py-2.border.border-gray-300.shadow-sm.text-sm.font-medium.rounded-md.text-gray-700.bg-white.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-primary-500
                   {:href (href :route.settings/events)}
                   (tr :action/details-fn (tr :route.title/events))]]]]]]

             [:section
              {:aria-labelledby "event-attendance"}
              [:div.rounded-lg.bg-gray-200.overflow-hidden.shadow.divide-y.divide-gray-200.sm:divide-y-0
               [:h2.sr-only
                {:id "event-attendance"}
                (tr :attendance)]
               [:div.bg-white.p-6
                [:div.flex.justify-between.pb-2
                 [:h2.font-semibold.text-gray-900.flex.justify-between.text-xl
                  (tr :attendance)]
                 [:div
                  [search-input
                   {:input-string !input-string
                    :on-change #(reset! !input-string (-> % .-target .-value))
                    :placeholder (tr :action/search)}]]]
                (let [bookings-by-start-time (->> filtered-bookings
                                                  (sort-by :startTime)
                                                  (group-by :startTime))
                      booking-times (->> current-bookings
                                         (map :startTime)
                                         (distinct)
                                         (sort))]
                  [:div
                   (doall
                    (for [booking-time booking-times
                          :let [bookings (get bookings-by-start-time booking-time)
                                checked-in-bookings (->> bookings
                                                         (filter #(some? (:checkIn %))))
                                checked-out-bookings (->> bookings
                                                          (filter #(some? (:checkOut %))))
                                bookings-by-room (index-by bookings :roomId)]]
                      ^{:key (str "bookings-by-time-" booking-time)}
                      [:div.pt-3.pb-5.px-5.sm:px-6.odd:bg-gray-50.even:bg-gray-100
                       [:div.flex
                        [:button.border.rounded-md.shadow-sm.inline-flex.justify-center.text-sm.font-medium.focus:outline-none.focus:ring-2.focus:ring-offset-2
                         {:type "button"
                          :class (cs "bg-white hover:bg-gray-50 focus:ring-red-500 text-gray-700 border-gray-300")
                          :on-click #(swap! !collapsed-state assoc booking-time (not (get @!collapsed-state booking-time true)))}
                         (if (get @!collapsed-state booking-time true)
                           [:> ChevronDownIcon
                            {:class "h-6 w-6 text-gray-500"}]
                           [:> ChevronRightIcon
                            {:class "h-6 w-6 text-gray-500"}])]
                        [:h2.text-gray-500.text-xl.ml-2.flex.items-center
                         booking-time
                         [:span.text-gray-400.ml-3
                          [:span.text-xs
                           "予約 "]
                          [:span.text-base.font-semibold
                           (count bookings)]
                          [:span.text-xs
                           "件・チェックイン "]
                          [:span.text-base.font-semibold
                           (count checked-in-bookings)]
                          [:span.text-xs
                           "件・チェックアウト "]
                          [:span.text-base.font-semibold
                           (count checked-out-bookings)]
                          [:span.text-xs
                           "件"]]]]
                       ;; Bookings for the given slot
                       (when (get @!collapsed-state booking-time true)
                         [:div.overflow-hidden.bg-white.shadow.sm:rounded-md.mt-2
                          [:ul.mt-3.divide-y.divide-gray-200
                           {:role "list"}
                           (doall
                            (for [booking bookings
                                  :let [boutique (get (listen ::event-organizer-subs/boutiques-by-boutique-id) (:boutiqueId booking))
                                        sales (get (listen ::subs/staffs-by-id) (:inviterId booking))]
                                  :when (some? booking)]
                              ^{:key (str "time-" booking-time "-room-" (:id booking))}
                              [:li
                               [:div.flex.items-center.px-4.py-4.sm:px-6
                                [:div.flex-shrink-0.mr-5
                                 [:div.flex.flex-col
                                  [:span.inline-flex.items-center.justify-center.rounded-full.bg-gray-200.font-semibold.h-8.w-8.text-sm
                                   (:externalId booking)]
                                  [:span.mt-2.inline-flex.items-center.justify-center.text-sm
                                   (str (:guestNumbers booking) "人")]]]
                                [:div.flex.w-80.items-center
                                 [:div
                                  [:div.flex
                                   [:div
                                    [:p.truncate.text-sm.font-medium.text-primary-500
                                     (str (:guestLastNameJp booking) " " (:guestFirstNameJp booking))]
                                    [:p.text-xs.text-gray-500.truncate.-mt-1
                                     (str (:guestLastName booking) " " (:guestFirstName booking))]
                                    [:p.text-xs.text-gray-500.font-mono
                                     (:clientId booking)]]
                                   [:div.flex
                                    (when (and (> (:guestNumbers booking) 1)
                                               (not (empty? (:accompanyingGuests booking))))
                                      [:span.relative
                                       [:div.group
                                        [guests-tooltip
                                         {:guests (:accompanyingGuests booking)}]
                                        [:> UsersIcon
                                         {:class "h-4 w-4 ml-2 text-gray-600"}]]])
                                    (when (not (blank? (:comment booking)))
                                      [:span.relative
                                       [:div.group
                                        [comment-tooltip
                                         {:comment (:comment booking)}]
                                        [:> AnnotationIcon
                                         {:class "h-4 w-4 ml-2 text-gray-600"}]]])]]
                                  [:div.flex.mt-2
                                   [:dt.text-sm.font-medium.text-gray-500.w-24
                                    (tr :booking/inviter)]
                                   [:dd.text-sm.text-gray-900.h-4.flex.space-x-3.truncate
                                    (:inviterName booking)]]
                                  [:div.flex
                                   [:dt.text-sm.font-medium.text-gray-500.w-24
                                    (str (tr :booking/boutiqueName) "/POS名" )]
                                   [:dd.text-sm.text-gray-900.h-4.truncate
                                    (if (blank? (:boutiqueName booking))
                                      (:posName booking)
                                      (:boutiqueName booking))]]]]
                                [:div.px-2.flex.justify-between.w-full
                                 [:div
                                  [progress
                                   {:disabled? (some? (:cancel booking))
                                    :steps [{:id (str (:id booking) "-check-in")
                                             :name (tr :booking.status/check-in)
                                             :ts (:checkIn booking)
                                             :on-click #(do
                                                          (when (nil? (:checkIn booking))
                                                            (re-frame/dispatch
                                                             [::booking-events/update-booking
                                                              {:booking (assoc booking
                                                                               :checkIn (listen ::subs/time))}]))
                                                          (reset! !booking-drawer-state {:is-open? true
                                                                                         :booking booking
                                                                                         :date @selected-date}))
                                             :current? (and
                                                        (some? (:checkIn booking))
                                                        (not (some? (:enter booking))))
                                             :checked? (some? (:checkIn booking))}
                                            {:id (str (:id booking) "-enter")
                                             :name (tr :booking.status/enter)
                                             :ts (:enter booking)
                                             :current? (and
                                                        (some? (:enter booking))
                                                        (not (some? (:exit booking))))
                                             :checked? (some? (:enter booking))}
                                            {:id (str (:id booking) "-exit")
                                             :name (tr :booking.status/exit)
                                             :ts (:exit booking)
                                             :current? (and
                                                        (some? (:exit booking))
                                                        (not (some? (:checkOut booking))))
                                             :checked? (some? (:exit booking))}
                                            {:id (str (:id booking) "-check-out")
                                             :name (tr :booking.status/check-out)
                                             :ts (:checkOut booking)
                                             :on-click #(do
                                                          (when
                                                              (and
                                                               (not (nil? (:exit booking)))
                                                               (nil? (:checkOut booking)))
                                                            (re-frame/dispatch
                                                             [::booking-events/update-booking
                                                              {:booking (assoc booking
                                                                               :checkOut (listen ::subs/time))}]))
                                                          (reset! !booking-drawer-state {:is-open? true
                                                                                         :booking booking
                                                                                         :date @selected-date}))
                                             :checked? (some? (:checkOut booking))}]}]]
                                 [:div
                                  (if (some? (:cancel booking))
                                    [button
                                     {:small? true
                                      :on-click #(re-frame/dispatch
                                                  [::booking-events/update-booking
                                                   {:booking (assoc booking :cancel nil)}])}
                                     (tr :action/uncancel)]
                                    [button
                                     {:small? true
                                      :intent :intent/default
                                      :on-click #(re-frame/dispatch
                                                  [::booking-events/update-booking
                                                   {:booking (assoc booking :cancel (listen ::subs/time))}])}
                                     (tr :action/cancel)])]]]]))]])]))])]]]])

          ;; Right Column
          [:div.grid.grid-cols-1.gap-4
           ;; Upcoming Events
           ]]]))))

(defn content []
  [:div
   (case (listen ::subs/current-route-name)
     :route.home/home [event-organizer-home-page]
     [:div])])
